import request from '../../request';

export interface ReportParams {
    startDate: string;
    endDate: string;
    projects?: string;
    employees?: string;
    customers?: string;
}

const requestReport = <T extends object>({ projects, ...params }: ReportParams, url: string) =>
    request<T>({
        url,
        params: {
            projects: projects !== '' ? projects : undefined,
            ...params
        }
    });

export default requestReport;
